
export function getNbnProductType(payload) {
    let data = null
    switch (payload) {
        case "Fibre":
        case "FTTP":
        case "Fibre to the Premises":
          data = "Fibre";
          break;
        case "Fibre To The Building":
          data = "FTTB";
          break;
        case "Fibre To The Node":
          data = "FTTN";
          break;
        case "Fibre To The Curb":
          data = "FTTC";
          break;
        case "Wireless":
          data = "Fixed Wireless";
          break;
        case "HFC":
          data = "HFC";
          break;
      }
        return data;
}
